import { Product } from '~app/modules/account/modules/buy-again/models';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GATrackingEventType,
  GaTrackingEventName,
  GaTrackingStringConstantEnum,
} from '~shared/modules/ga-tracking/constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import {
  GetCategoryTreeArrayWithNameAndId,
  GetCategoryTreeNamesArray,
  GetLeafCategoryId
} from '~app/modules/generic/helpers';
import { Category } from '~app/modules/generic/models';
import get from 'lodash.get';

export class GaTrackingItemListBuyAgainEventModel {

  constructor(
    private products: Product[],
    private priceType: PriceTypes,
    private previousProductsShownLength = 0,
    private isLabelDisabled,
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ListView;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.ListView,
      label: this.isLabelDisabled ? undefined : this.products[0]?.breadcrumbsFull.name,
      gtmCustom: {
        ecommerce: {
          currencyCode: 'EUR',
          impressions: this.products.filter(x => x.bestOffer).map((product: Product, index: number) => {
            const leafCategoryId = GetLeafCategoryId(this.getAllCategories(product.breadcrumbsFull));
            return {
              name: get(product, 'name'),
              id: get(product, 'id'),
              'price': this.priceType === PriceTypes.b2c ? get(product, 'bestOffer.price.vatIncluded.amount', 0)
                : get(product, 'bestOffer.price.vatExcluded.amount', 0),
              brand: get(product, 'brand.name', ''),
              category: GetCategoryTreeNamesArray(this.getAllCategories(product.breadcrumbsFull)).join('/'),
              category_tree: GetCategoryTreeArrayWithNameAndId(this.getAllCategories(product.breadcrumbsFull)),
              category_id: leafCategoryId,
              list: 'Buy Again',
              position: this.previousProductsShownLength + index + 1,
              dimension12: get(product, 'hasPromotion', false),
              dimension14: product.bestOffer.volumePrice?.length > 0
                  ? GaTrackingStringConstantEnum.Yes
                  : GaTrackingStringConstantEnum.No,
            };
          })
        }
      }
    };
  }
  private getAllCategories(category: Category): any {
    if (category instanceof Category) {
      const categories = [...category.parents].reverse();
      categories.push({
        id: category.id,
        name: category.name,
        slug: category.slug,
        children: [],
      });
      return categories;
    } else {
      return null
    }
  }

}
